import SearchBar from './components/SearchBar';

export default SearchBar;
